import { VirtualDataRoomSelectNode } from "@/components/data-room/VirtualRoomsSelectTree";
import { GeneralFileNodeType } from "@/enums/DocumentCenterFileType";

export const getActiveTree = (tree: VirtualDataRoomSelectNode) => {
  let newTree = structuredClone(tree);
  let stack = [newTree];
  while (stack.length > 0) {
    let e = stack.pop();
    if (e.entries) {
      e.entries = e.entries.filter((i) => i.count > 0 || i.type === GeneralFileNodeType.FILE);
      for (let newI of e.entries) {
        stack.push(newI);
      }
    }
  }
  return newTree;
};

export const FILE_CANNOT_BE_ANALYZED_MESSAGE =
  "This file couldn't be analyzed. This may happen if it only consists of images or has no text.";
